import { get, post, patch, destroy } from "@/lib/fetcher";

export async function getCandidates(params = {}) {
    return await get("/admin/candidates", params);
}

export async function getCandidate(id) {
    return await get(`/admin/candidates/${id}`);
}

export async function postCandidate(data) {
    return await post("/admin/candidates", data);
}

export async function patchCandidate(id, data) {
    return await patch(`/admin/candidates/${id}`, data);
}

export async function deleteCandidate(id) {
    return await destroy(`/admin/candidates/${id}`);
}

export async function enableCandidateLogin(id){
    return await patch (`/admin/candidates/${id}/enable_login`)
}

export async function disbaleCandidateLogin(id){
    return await patch (`/admin/candidates/${id}/disable_login`)
}
